<template>
  <div class="page page-roadshow-list">
    <a-button-group>
      <!-- <a-button @click="tab = 'all'" :type="tab == 'all' ? 'primary' : 'default'">全部</a-button> -->
      <a-button @click="tab = 'syslogin'" :type="tab == 'syslogin' ? 'primary' : 'default'">管理系统登录日志</a-button>
      <a-button @click="tab = 'login'" :type="tab == 'login' ? 'primary' : 'default'">协同系统登录日志</a-button>
      <a-button @click="tab = 'project'" :type="tab == 'project' ? 'primary' : 'default'">项目操作日志</a-button>
      <a-button @click="tab = 'sys'" :type="tab == 'sys' ? 'primary' : 'default'">所有操作日志</a-button>
      <!-- <a-button @click="tab = 'sms'" :type="tab == 'sms' ? 'primary' : 'default'">短信发送日志</a-button> -->
    </a-button-group>
    <div class="list-options v-mt-sm">
      <a-form layout="inline" class="options-form">
        <a-row :gutter="24" v-if="tab == 'syslogin'">
          <a-col span="8">
            <a-form-item :colon="false" label="系统用户"><a-input placeholder="用户账号/姓名" @keyup.enter="handleSearch" allow-clear v-model="loginForm.user" size="default" style="width: 200px" /></a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item :colon="false" label="操作类型">
              <a-checkbox-group v-model="loginForm.actions">
                <a-checkbox v-for="action in sysloginActions" :key="action.value" :value="action.value">{{ action.label }}</a-checkbox>
              </a-checkbox-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-else-if="tab == 'login'">
          <a-col span="8">
            <a-form-item :colon="false" label="社区用户"><a-input placeholder="用户账号/名称/手机" @keyup.enter="handleSearch" allow-clear v-model="loginForm.user" size="default" style="width: 200px" /></a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item :colon="false" label="操作类型">
              <a-checkbox-group v-model="loginForm.actions">
                <a-checkbox v-for="action in loginActions" :key="action.value" :value="action.value">{{ action.label }}</a-checkbox>
              </a-checkbox-group>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-else-if="tab == 'project'">
          <a-col span="8">
            <a-form-item :colon="false" label="项目名称"><a-input placeholder="项目名称" @keyup.enter="handleSearch" allow-clear v-model="projectForm.project" size="default" style="width: 200px" /></a-form-item>
          </a-col>
          <!-- <a-col span="8">
            <a-form-item :colon="false" label="项目类型">
              <a-select placeholder="请选择" v-model="projectForm.biz" size="default" style="width: 200px" allowClear>
                <a-select-option value="-1">全部</a-select-option>
                <a-select-option v-for="item in projectBizs" :value="item.value" :key="item.value">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col span="8">
            <a-form-item :colon="false" label="操作用户"><a-input placeholder="用户账号/姓名" @keyup.enter="handleSearch" allow-clear v-model="projectForm.user" size="default" style="width: 200px" /></a-form-item>
          </a-col>
          <!-- <a-col span="24">
            <a-form-item :colon="false" label="操作类型">
              <div class="filter-checkbox" v-if="!projectForm.biz || projectForm.biz === '-1' || projectForm.biz === 'PROJECT_OWN'">
                <div class="flex items-center"><span class="text-bold text-indigo">执行类项目：</span></div>
                <div style="margin-top: -4px">
                  <a-checkbox-group v-model="projectForm.ownActions">
                    <a-checkbox v-for="action in projectOwnActions" :key="action.value" :value="action.value">{{ action.label }}</a-checkbox>
                  </a-checkbox-group>
                </div>
              </div>
              <div class="filter-checkbox" v-if="!projectForm.biz || projectForm.biz === '-1' || projectForm.biz === 'PROJECT_FUNDED'">
                <div class="flex items-center"><span class="text-bold text-indigo">资助类项目：</span></div>
                <div style="margin-top: -4px">
                  <a-checkbox-group v-model="projectForm.fundedActions">
                    <a-checkbox v-for="action in projectFundedActions" :key="action.value" :value="action.value">{{ action.label }}</a-checkbox>
                  </a-checkbox-group>
                </div>
              </div>
              <div class="filter-checkbox" v-if="!projectForm.biz || projectForm.biz === '-1' || projectForm.biz === 'PROJECT_OTHER'">
                <div class="flex items-center"><span class="text-bold text-indigo">其他类项目：</span></div>
                <div style="margin-top: -4px">
                  <a-checkbox-group v-model="projectForm.otherActions">
                    <a-checkbox v-for="action in projectOtherActions" :key="action.value" :value="action.value">{{ action.label }}</a-checkbox>
                  </a-checkbox-group>
                </div>
              </div>
            </a-form-item>
          </a-col> -->
        </a-row>
        <a-row :gutter="24" v-else-if="tab == 'sys'">
          <a-col span="8">
            <a-form-item :colon="false" label="操作用户"><a-input placeholder="用户账号/姓名" @keyup.enter="handleSearch" allow-clear v-model="sysForm.user" size="default" style="width: 200px" /></a-form-item>
          </a-col>
          <!-- <a-col span="8">
            <a-form-item :colon="false" label="操作对象">
              <a-select placeholder="请选择" v-model="sysForm.biz" size="default" style="width: 200px" allowClear>
                <a-select-option value="-1">全部</a-select-option>
                <a-select-option v-for="item in allBizs" :value="item.value" :key="item.value">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
        </a-row>
      </a-form>
    </div>
    <div class="flex items-center v-my-sm">
      <div class="v-ml-auto">
        <a-space>
          <a-button type="primary" icon="search" size="small" @click="handleSearch">查询</a-button>
          <!-- <a-button icon="plus" type="primary" size="small" @click="$router.push('add')">新增项目</a-button> -->
          <!-- <a-button icon="file-excel" type="danger" size="small" @click="$router.push('add')">导出</a-button> -->
        </a-space>
      </div>
    </div>
    <div class="list-table-container">
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
      <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="loading" :data-source="list" :scroll="{ x: '100%' }" rowKey="opId" v-if="tab == 'syslogin' || tab == 'login'">
        <a-table-column title="#" data-index="index" :width="45" align="center" fixed="left">
          <template slot-scope="text, record, index">{{ index + 1 }}</template>
        </a-table-column>
        <a-table-column title="操作用户" data-index="opUser" align="left" />
        <!-- <a-table-column title="用户手机" data-index="user.phone" align="left" /> -->
        <a-table-column title="操作" data-index="opType" align="left">
          <template slot-scope="text, record">
            {{ record.opType }}
            <template v-if="record.opTypeCode && record.opTypeCode.endsWith('REVIEW')">
              <a-tag color="#3f51b5" class="tag-tiny" v-if="record.opStatus === 1">通过</a-tag>
              <a-tag color="#ee1100" class="tag-tiny" v-else-if="record.opStatus === 0">驳回</a-tag>
            </template>
          </template>
        </a-table-column>
        <a-table-column title="操作IP" data-index="opIp" align="left" />
        <a-table-column title="操作时间" data-index="opTime" align="center" />
      </a-table>
      <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="loading" :columns="projectCols" :data-source="list" :scroll="{ x: '100%' }" rowKey="opId" v-if="tab == 'project'">
        <template slot="projectName" slot-scope="text, record">
          <span v-if="record.project">{{ record.project.name }}</span>
        </template>
        <template slot="projectType" slot-scope="text, record" v-if="record.project">
          <span v-if="record.project.type === 11">合作项目-公募合作</span>
          <span v-else-if="record.project.type === 12">合作项目-专项基金</span>
          <span v-else-if="record.project.type === 21">自有项目-螺蛳壳改造</span>
          <span v-else-if="record.project.type === 22">自有项目-精灵书屋</span>
          <span v-else-if="record.project.type === 23">自有项目-公益人才</span>
          <span v-else-if="record.project.type === 24">自有项目-爱心100</span>
          <span v-else-if="record.project.type === 25">自有项目-其他项目</span>
        </template>
        <template slot="opType" slot-scope="text, record">
          {{ record.opType }}
          <template v-if="record.opTypeCode && record.opTypeCode.endsWith('REVIEW')">
            <a-tag color="#3f51b5" class="tag-tiny" v-if="record.opStatus === 1">通过</a-tag>
            <a-tag color="#ee1100" class="tag-tiny" v-else-if="record.opStatus === 0">驳回</a-tag>
          </template>
        </template>
      </a-table>
      <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="loading" :columns="sysCols" :data-source="list" :scroll="{ x: '100%' }" rowKey="opId" v-if="tab == 'sys'"></a-table>
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const TAB_STATE = {
  uncheck: [1],
  checked: [2, 3],
  reject: [-1],
}
import { listLog } from '@/api/system/log'
export default {
  data() {
    return {
      tab: '',
      loading: false,
      list: [],
      loginCols: [
        {
          title: '#',
          dataIndex: 'id',
          width: 55,
          align: 'center',
          // fixed: 'left',
          customRender: (text, record, index) => index + 1,
        },
        {
          title: '操作用户',
          ellipsis: true,
          dataIndex: 'opUser',
          // width: 250,
        },
        {
          title: '操作',
          ellipsis: true,
          dataIndex: 'opType',
          // width: 250,
        },
        {
          title: '操作IP',
          ellipsis: true,
          dataIndex: 'opIp',
          // width: 250,
        },
        {
          title: '操作时间',
          ellipsis: true,
          dataIndex: 'opTime',
          // width: 250,
        },
      ],
      projectCols: [
        {
          title: '#',
          dataIndex: 'id',
          width: 55,
          align: 'center',
          // fixed: 'left',
          customRender: (text, record, index) => index + 1,
        },
        {
          title: '操作用户',
          ellipsis: true,
          dataIndex: 'opUser',
          // width: 250,
        },
        {
          title: '操作',
          ellipsis: true,
          dataIndex: 'opType',
          scopedSlots: { customRender: 'opType' },
          // width: 250,
        },
        {
          title: '项目名称',
          ellipsis: true,
          dataIndex: 'projectName',
          scopedSlots: { customRender: 'projectName' },
          // width: 250,
        },
        {
          title: '项目类型',
          ellipsis: true,
          dataIndex: 'projectType',
          scopedSlots: { customRender: 'projectType' },
          // width: 250,
        },
        {
          title: '操作IP',
          ellipsis: true,
          dataIndex: 'opIp',
          width: 130,
        },
        {
          title: '操作时间',
          ellipsis: true,
          dataIndex: 'opTime',
          width: 160,
          // width: 250,
        },
      ],
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: 55,
          align: 'center',
          // fixed: 'left',
          customRender: (text, record, index) => index + 1,
        },
        {
          title: '申请人名称',
          ellipsis: true,
          dataIndex: 'realName',
          width: 250,
          // fixed: 'left',
          scopedSlots: { customRender: 'realName' },
        },
        {
          title: '申请人类型',
          dataIndex: 'userType',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'userType' },
        },
        {
          title: '注册手机',
          dataIndex: 'phone',
          width: 110,
          // ellipsis: true,
          // scopedSlots: { customRender: 'contact' },
        },
        {
          title: '机构性质',
          dataIndex: 'orgType',
          width: 90,
          ellipsis: true,
          align: 'center',
        },
        {
          title: '机构代码',
          dataIndex: 'code',
          width: 160,
        },
        {
          title: '机构注册日期',
          dataIndex: 'orgRegDate',
          width: 120,
          align: 'center',
        },
        {
          title: '状态',
          dataIndex: 'state',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'state' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 80,
          scopedSlots: { customRender: 'action' },
        },
      ],
      sysCols: [
        {
          title: '#',
          dataIndex: 'id',
          width: 55,
          align: 'center',
          // fixed: 'left',
          customRender: (text, record, index) => index + 1,
        },
        {
          title: '操作用户',
          ellipsis: true,
          dataIndex: 'opUser',
          // width: 250,
        },
        {
          title: '操作',
          ellipsis: true,
          dataIndex: 'opType',
          // width: 250,
        },
        {
          title: '操作对象',
          ellipsis: true,
          dataIndex: 'opBiz',
          // width: 250,
        },
        {
          title: '操作IP',
          ellipsis: true,
          dataIndex: 'opIp',
          // width: 250,
        },
        {
          title: '操作时间',
          ellipsis: true,
          dataIndex: 'opTime',
          // width: 250,
        },
      ],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      form: {
        realName: '',
        phone: '',
      },
      sysloginActions: [
        { value: 'SYSTEM_USER_LOGIN', label: '登录系统' },
        { value: 'SYSTEM_USER_LOGOUt', label: '退出系统' },
      ],
      loginForm: {
        user: '',
        actions: [],
      },
      loginActions: [
        { value: 'USER_LOGIN', label: '登入社区' },
        { value: 'USER_LOGOUt', label: '退出社区' },
      ],
      projectBizs: [
        { value: 'PROJECT', label: '项目' },
        { value: 'PROJECT_HZ', label: '合作项目' },
        { value: 'PROJECT_HOUSE', label: '螺蛳壳改造' },
        { value: 'PROJECT_SCHOOL', label: '精灵书屋' },
        { value: 'PROJECT_TALENT', label: '公益人才' },
        { value: 'PROJECT_LOVE', label: '爱心100' },
        { value: 'PROJECT_OTHER', label: '其他项目' },
      ],
      projectForm: {
        project: '',
        user: '',
        biz: undefined,
        ownActions: [],
        fundedActions: [],
        otherActions: [],
      },
      projectOwnActions: [
        { value: 'PROJECT_OWN_NEW', label: '添加项目' },
        { value: 'PROJECT_OWN_UPDATE', label: '修改项目' },
        { value: 'PROJECT_PLAN_ADD', label: '添加项目计划' },
        { value: 'PROJECT_PLAN_REMOVE', label: '删除项目计划' },
        { value: 'PROJECT_PLAN_UPDATE', label: '编辑项目计划' },
        { value: 'PROJECT_REPORT_ADD', label: '添加文档编制计划' },
        { value: 'PROJECT_REPORT_REMOVE', label: '删除文档编制计划' },
        { value: 'PROJECT_REPORT_SUBMIT', label: '提交计划文档' },
      ],
      projectFundedActions: [
        { value: 'PROJECT_FUNDED_APPLY_DRAFT', label: '保存项目意向初稿' },
        { value: 'PROJECT_FUNDED_APPLY_SUBMIT', label: '提交项目意向' },
        { value: 'PROJECT_FUNDED_REVIEW', label: '项目评审' },
        { value: 'PROJECT_FUNDED_DECLARE_DRAFT', label: '项目申报书初稿' },
        { value: 'PROJECT_FUNDED_DECLARE_SUBMIT', label: '提交项目申报书' },
        { value: 'PROJECT_FUNDED_DECLARE_CHECK', label: '项目申报书审核' },
        { value: 'PROJECT_FUNDED_SIGN', label: '签订资助协议' },
        { value: 'PROJECT_FUNDED_BACKWARD', label: '退回至上一阶段' },
        { value: 'PROJECT_CHANGEINFO_DRAFT', label: '保存项目变更初稿' },
        { value: 'PROJECT_CHANGEINFO_SUBMIT', label: '提交项目变更申请' },
        { value: 'PROJECT_CHANGEINFO_CHECK', label: '项目变更审核' },
        { value: 'PROJECT_CHANGEINFO_REMOVE', label: '删除项目变更' },
        { value: 'PROJECT_REPORT_ADD', label: '添加文档编制计划' },
        { value: 'PROJECT_REPORT_REMOVE', label: '删除文档编制计划' },
        { value: 'PROJECT_REPORT_UPLOAD', label: '上传计划文档' },
        { value: 'PROJECT_REPORT_SUBMIT', label: '提交计划文档' },
        { value: 'PROJECT_REPORT_CHECK', label: '审核计划文档' },
        { value: 'PROJECT_FUNDED_DONE', label: '资助执行结束' },
        { value: 'PROJECT_FUNDED_CLOSE', label: '项目结项' },
        { value: 'PROJECT_FUNDED_STOP', label: '终止项目' },
      ],
      projectOtherActions: [
        { value: 'PROJECT_OTHER_NEW', label: '添加项目' },
        { value: 'PROJECT_OTHER_REMOVE', label: '删除项目' },
      ],
      allBizs: [
        { value: 'CAPITAL_POOL', label: '资金池' },
        { value: 'PROJECT_HZ', label: '合作项目' },
        { value: 'PROJECT_FUNDED', label: '资助项目' },
        { value: 'PROJECT_OTHER', label: '其他项目' },
        { value: 'USER', label: '社区会员' },
        { value: 'SYSTEM_USER', label: '系统用户' },
        { value: 'SYSTEM_ROLE', label: '系统角色' },
      ],
      sysForm: {
        user: '',
        biz: undefined,
      },
    }
  },
  watch: {
    tab(tab) {
      if (tab === 'syslogin') {
        this.loginForm.actions = this.sysloginActions.map(item => item.value)
      } else if (tab === 'login') {
        this.loginForm.actions = this.loginActions.map(item => item.value)
      } else if (tab === 'project') {
        this.projectForm.ownActions = this.projectOwnActions.map(item => item.value)
        this.projectForm.fundedActions = this.projectFundedActions.map(item => item.value)
        this.projectForm.otherActions = this.projectOtherActions.map(item => item.value)
      }
      this.load()
    },
  },
  computed: {
    stages: vm => vm.$store.state.app.stages,
    roadshowTypes: vm => vm.$store.state.app.roadshowTypes,
  },
  methods: {
    handleSearch() {
      this.load()
    },
    handleReset() {
      this.form.resetFields()
    },
    load(page = 1, pageSize = 10, sorter) {
      this.loading = true
      let { tab, projectBizs } = this
      let params = {
        page,
        pageSize,
      }
      if (tab === 'syslogin' || tab === 'login') {
        params = Object.assign(params, this.loginForm)
      } else if (tab === 'project') {
        let { project, user } = this.projectForm
        params.project = project.trim()
        params.user = user.trim()
        params.bizs = projectBizs.map(item => item.value)
        // let actions = []
        // if (!biz || biz === '-1') {
        //   params.bizs = projectBizs.map(item => item.value)
        //   actions = [...ownActions, ...fundedActions, ...otherActions]
        // } else {
        //   params.biz = biz
        //   if (biz === 'PROJECT_OWN') {
        //     actions = [...ownActions]
        //   } else if (biz === 'PROJECT_FUNDED') {
        //     actions = [...fundedActions]
        //   } else if (biz === 'PROJECT_OTHER') {
        //     actions = [...otherActions]
        //   }
        // }
        // params.actions = actions
      } else if (tab === 'sys') {
        let { user, biz } = this.sysForm
        if (biz !== '-1') {
          params.biz = biz
        }
        params.user = user
      }
      listLog(params)
        .then(({ data }) => {
          if (data.success) {
            let { current, size, total, records } = data.result
            this.list = records
            this.pagination = {
              page: current,
              pageSize: size,
              total,
            }
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onPageChange(page, pageSize) {
      this.load(page, pageSize)
    },
  },
  mounted() {
    this.tab = this.$route.query.tab || 'syslogin'
  },
}
</script>

<style lang="stylus" scoped>
.ant-form-item-label
  min-width 100px
</style>
